const helper = {
  tableName: 'nsession', // 存储表名
  // 获取token
  localData: function (key, obj) {
    var tmp = localStorage.getItem(key)
    if (!obj) {
      return JSON.parse(tmp)
    }
    var data = {}
    if (tmp && tmp.length > 0) {
      data = JSON.parse(tmp)
      if (!obj.key) {
        return ''
      }
      var keyL = obj.key
      if (obj.remove) {
        delete data[keyL]
      } else if (obj.value) {
        data[keyL] = obj.value
      }
      localStorage.setItem(key, JSON.stringify(data))
    } else {
      if (!obj.key) {
        return ''
      }
      data[obj.key] = obj.value
      localStorage.setItem(key, JSON.stringify(data))
    }
    return ''
  },
  sessionData: function (key, obj) {
    var tmp = sessionStorage.getItem(key)
    if (!obj) {
      return JSON.parse(tmp)
    }
    if (tmp.length > 0) {
      var data = JSON.parse(tmp)
      if (!obj.key) {
        return ''
      }
      var keyL = obj.key
      if (obj.remove) {
        delete data[keyL]
      } else if (obj.value) {
        data[keyL] = obj.value
      }
      sessionStorage.setItem(key, JSON.stringify(data))
    }
    return ''
  },
  getLogin: function () {
    var t = this.localData(helper.tableName)
    console.log('helper nsseion', t)
    if (t) {
      return t.flag
    }
    return null
  },
  // 清除token
  removeLogin: function () {
    this.localData(helper.tableName, {
      key: 'flag',
      remove: true
    })
    this.localData(helper.tableName, {
      key: 'fp',
      remove: true
    })
  },
  // 缓存token
  putLogin: function (flag) {
    this.localData(helper.tableName, {
      key: 'flag',
      value: flag
    })
  },
  getFprint: function () {
    var t = this.localData(helper.tableName)
    // console.log('helper nsseion', t)
    if (t) {
      return t.fp
    }
    return false
  },
  // 清除token
  removeFprint: function () {
    this.localData(helper.tableName, {
      key: 'fp',
      remove: true
    })
  },
  // 缓存token
  putFprint: function (flag) {
    this.localData(helper.tableName, {
      key: 'fp',
      value: flag
    })
  },

  // 获取当前登录user
  getUser: function () {
    var t = this.localData(helper.tableName)
    var u = null
    if (t) {
      u = t.login_user
    } else {
      return null
    }
    if (u) {
      return JSON.parse(u)
    }
    return null
  },
  // 缓存user
  putUser: function (user) {
    this.localData(helper.tableName, {
      key: 'login_user',
      value: JSON.stringify(user)
    })
  },
  removeUser: function () {
    this.localData(helper.tableName, {
      key: 'login_user',
      remove: true
    })
  },
  // 缓存临时数据
  putTempData: function (key, value) {
    if (value) {
      this.sessionData('tempData', {key: key, value: value})
    } else {
      this.sessionData('tempData', {key: key, remove: true})
    }
  },
  // 获取缓存临时数据
  getTempData: function (key) {
    return this.sessionData('tempData')[key]
  },
  dateFormat: function (timestamp, formats) {
    // timestamp 秒
    // formats格式包括
    // 1. Y-m-d
    // 2. Y-m-d H:i:s
    // 3. Y年m月d日
    // 4. Y年m月d日 H时i分
    formats = formats || 'Y-m-d'

    var zero = function (value) {
      if (value < 10) {
        return '0' + value
      }
      return value
    }
    var myDate = timestamp ? new Date(timestamp * 1000) : new Date()

    var year = myDate.getFullYear()
    var month = zero(myDate.getMonth() + 1)
    var day = zero(myDate.getDate())

    var hour = zero(myDate.getHours())
    var minite = zero(myDate.getMinutes())
    var second = zero(myDate.getSeconds())

    return formats.replace(/Y|m|d|H|i|s/ig, function (matches) {
      return ({
        Y: year,
        m: month,
        d: day,
        H: hour,
        i: minite,
        s: second
      })[matches]
    })
  },
  getCurTime () {
    return Math.floor(Date.now() / 1000)
  },
  // vip 相关的函数
  getName (val) {
    var username = '个人中心'
    if (val && val.status === 1) {
      if (val.email) {
        return val.email
      } else {
        return username
      }
    }
    return username
  },
  // 获取可以同时采集的关键词数量
  getKwNum (val) {
    var num = 5
    if (val && val.status === 1) {
      if (val.type === 0) {
        if (val.count && val.count > 10) {
          num = 500
        } else {
          num = 500
        }
      }
      if (val.type === 1) {
        var t = helper.getCurTime()
        if (t < val.end_at) {
          if (val.s_type === 1) {
            num = 5
          }
          if (val.s_type === 2) {
            num = 10
          }
          if (val.s_type === 3) {
            num = 500
          }
        }
      }
    }
    return num
  },
  // 获取可以同时采集的地区数量
  getRegionNum (val) {
    var num = 5
    if (val && val.status === 1) {
      if (val.type === 0) {
        if (val.count && val.count > 10) {
          num = 500
        } else {
          num = 500
        }
      }
      if (val.type === 1) {
        var t = helper.getCurTime()
        if (t < val.end_at) {
          if (val.s_type === 1) {
            num = 1
          }
          if (val.s_type === 2) {
            num = 5
          }
          if (val.s_type === 3) {
            num = 500
          }
        }
      }
    }
    return num
  }
}

export default helper



// WEBPACK FOOTER //
// ./src/lib/helper.js